namespace Solovis.UI {

    export class ErrorControl extends Solovis.UI.BaseControl {

        private _error;

        public static _log: boolean;

        constructor(options) {
            super(options);

            this._error = options.error;

            if (ErrorControl._log) {
                console.log("ERROR: reported to ErrorControl (see below)");
                console.log(this._error);
            }
        }

        public doRender() {
            if (!this._error) {
                this.container.text("Unspecified error.");
            }
            else if (typeof this._error === "string") {
                this.container.text(this._error);
            }
            else {
                if (this._error.error?.message) {
                    this.container.text(this._error.error.message);
                }
                else if (this._error.error?.html) {
                    this.container.css("max-height", "500px");
                    this.container.html(this._error.error.html);
                }
                else if (this._error) {
                    this.container.text("An error has occurred.");
                }
            }
        }
    }

}